import React from 'react'
import T from 'prop-types'
import { styled } from '@mui/material/styles'
import BoltIcon from '@mui/icons-material/Bolt'
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined'
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined'
import LocalGasStationOutlinedIcon from '@mui/icons-material/LocalGasStationOutlined'
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined'
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined'
import { useTranslation } from 'react-i18next'
import {
  getFormattedKm,
  getFormattedAmount,
  getFormattedNumber,
} from 'lib/carDetailsLib'
import { Box } from '@mui/material'
import { format } from 'date-fns'
import itLocale from 'date-fns/locale/it'
import { COUNTRY_CONFIG_MAP } from 'lib/countryConfig'
import config from 'config'

import SixtIcon from 'components/atoms/SixtIcon'

import CarSpecification from './CarSpecification'

const classes = {
  carSpecifications: 'car-specifications',
}
const Root = styled('div')(({ theme }) => ({
  [`&.${classes.carSpecifications}`]: {
    display: 'flex',
  },
}))

export default function CarSpecifications({ car, price, fee, isAssignment }) {
  const { t } = useTranslation()

  const countryConfig = COUNTRY_CONFIG_MAP[config.country ?? 'it']

  return (
    <Root className={classes.carSpecifications}>
      <div>
        <CarSpecification
          icon={SpeedOutlinedIcon}
          value={getFormattedKm(car.km)}
          sx={{ whiteSpace: 'nowrap' }}
        />
        <CarSpecification
          icon={CalendarTodayOutlinedIcon}
          value={format(new Date(car.date), t('common.date.formatMY'), {
            locale: itLocale,
          })}
          sx={{ whiteSpace: 'nowrap' }}
        />
      </div>
      <div>
        <CarSpecification
          icon={LocalGasStationOutlinedIcon}
          value={car.fuelType}
          sx={{ whiteSpace: 'nowrap' }}
        />

        <CarSpecification
          icon={DirectionsCarOutlinedIcon}
          value={car[countryConfig.attribute.primary]}
          sx={{ whiteSpace: 'nowrap' }}
        />
      </div>
      <div>
        <CarSpecification
          icon={AccountTreeOutlinedIcon}
          value={t(`carDetails.mapping.${car.transmission}`)}
          sx={{ whiteSpace: 'nowrap' }}
        />
        <CarSpecification
          icon={<SixtIcon />}
          value={getFormattedAmount(price || car.price)}
          sx={{ whiteSpace: 'nowrap' }}
        />
      </div>
      <div>
        <CarSpecification
          icon={BoltIcon}
          value={
            car.enginePowerHp
              ? `${getFormattedNumber(car.enginePowerHp)} cv`
              : ''
          }
          sx={{ pr: 0, whiteSpace: 'nowrap' }}
        />
        <CarSpecification
          icon={DiamondOutlinedIcon}
          value={getFormattedAmount(isAssignment ? fee : fee || car.fee)}
          sx={{ pr: 0, whiteSpace: 'nowrap' }}
        />
        <Box />
      </div>
    </Root>
  )
}

CarSpecifications.propTypes = {
  car: T.object.isRequired,
}
